import { useState } from "react";
import {
  Box,
  Typography,
  TextField,
  IconButton,
  Paper,
  InputAdornment,
  Button, 
  Modal
} from "@mui/material";
import Logocolor from "../../Image/Logo.png";
import { BsSearch } from "react-icons/bs";
import { useBuscarPaciente } from "../../Services/BusquedaPaciente";
import { useNavigate } from "react-router-dom";
import {
  buttonCancelar,
  buttonGuardar,
  TituloColor,
  SubTitulo
} from "../../Layouts/CustomStyles";

export const BuscadorAdmin = () => {
  const navigate = useNavigate();
  const { buscarPaciente } = useBuscarPaciente();

  const [rutBuscar, setRutBuscar] = useState("");
  const [pacienteEncontrado, setPacienteEncontrado] = useState(null);

  const [openModalSuccess, setOpenModalSuccess] = useState(false);
  const [openModalError, setOpenModalError] = useState(false);

  // limpiar rut
  const limpiarRut = (rut) =>
    rut.replace(/\./g, "").replace(/-/g, "").trim();

  const handleBuscarPaciente = async () => {
    if (!rutBuscar.trim()) return;

    const rutLimpio = limpiarRut(rutBuscar);
    const result = await buscarPaciente(rutLimpio);

    if (result.ok) {
      setPacienteEncontrado(result.data);
      setOpenModalSuccess(true);
    } else {
      setPacienteEncontrado(null);
      setOpenModalError(true);
    }
  };

  const handleIrFicha = () => {
    if (pacienteEncontrado?.ingresos?.[0]?.paciente?.rut) {
      setOpenModalSuccess(false);

      setTimeout(() => {
        navigate(`/paciente/${pacienteEncontrado.ingresos[0].paciente.rut}`);
      }, 150);
    }
  };
  return (
    <Box
      sx={{
        height: "80vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        background: "linear-gradient(135deg, #e8f5e9, #ffffff)",
      }}
    >
      <Paper
        elevation={6}
        sx={{
          p: 6,
          borderRadius: "20px",
          width: "100%",
          maxWidth: "700px",
          textAlign: "center",
          display:'flex',
          alignItems:'center',
          justifyContent:'center',
          flexDirection:'column'
        }}
      >
        <Box display="flex" alignItems="center" gap={2}>
                        <img
                            src={Logocolor}
                            alt="Logo Clínica Activa"
                            style={{ width: 200, height: 200, objectFit: "contain" }}
                        />
                        </Box>
        <Typography
          sx={{
            fontFamily: "Poppins",
            fontWeight: 600,
            fontSize: "2rem",
            color: "#2a8d74",
            mb: 1,
          }}
        >
          Bienvenido al Sistema Contable
        </Typography>

        <Typography
          sx={{
            fontFamily: "Poppins",
            fontWeight: 600,
            fontSize: "1.6rem",
            color: "#585857",
            mb: 3,
          }}
        >
          Alemana Activa
        </Typography>

        {/* 📝 DESCRIPCIÓN */}
        <Typography
          sx={{
            fontFamily: "Poppins",
            color: "#585857",
            mb: 4,
          }}
        >
          Ingresa el RUT del paciente para visualizar su ficha y estado actual.
        </Typography>

        {/* 🔍 BUSCADOR GRANDE */}
        <TextField
          fullWidth
          placeholder="Ej: 12.345.678-9"
          value={rutBuscar}
          onChange={(e) => setRutBuscar(e.target.value)}
          onKeyPress={(e) => e.key === "Enter" && handleBuscarPaciente()}
          sx={{
            mb: 3,
            "& .MuiInputBase-root": {
              borderRadius: "30px",
              fontSize: "1.2rem",
              padding: "8px 15px",
            },
          }}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  onClick={handleBuscarPaciente}
                  sx={{
                    background: "#2a8d74",
                    color: "#fff",
                    "&:hover": {
                      background: "#226f5c",
                    },
                  }}
                >
                  <BsSearch />
                </IconButton>
              </InputAdornment>
            ),
          }}
        />

        {/* BOTÓN OPCIONAL */}
        <Button
          variant="contained"
          onClick={handleBuscarPaciente}
          sx={{
            borderRadius: "20px",
            background: "#2a8d74",
            px: 4,
            py: 1,
            fontFamily: "Poppins",
            textTransform: "none",
            "&:hover": {
              background: "#226f5c",
            },
          }}
        >
          Buscar Paciente
        </Button>
      </Paper>
        {/* ✅ MODAL ÉXITO */}
      <Modal open={openModalSuccess} onClose={() => setOpenModalSuccess(false)}>
        <Box sx={{
          width: 400, bgcolor: "white", p: 3, borderRadius: "10px",
          mx: "auto", mt: "15%", boxShadow: 5
        }}>
          <Typography variant="h6" sx={TituloColor}>
            Paciente encontrado
          </Typography>

          <Typography sx={{ ...SubTitulo, mt: 1, mb: 3 }}>
            ¿Deseas ver la ficha del paciente?
          </Typography>

          <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 1 }}>
            <Button sx={buttonCancelar} onClick={() => setOpenModalSuccess(false)}>
              Cancelar
            </Button>

            <Button sx={buttonGuardar} variant="contained" onClick={handleIrFicha}>
              Ver ficha paciente
            </Button>
          </Box>
        </Box>
      </Modal>

      {/* ❌ MODAL ERROR */}
      <Modal open={openModalError} onClose={() => setOpenModalError(false)}>
        <Box sx={{
          width: 380, bgcolor: "white", p: 3, borderRadius: "10px",
          mx: "auto", mt: "18%", boxShadow: 5
        }}>
          <Typography variant="h6" sx={{ color: "red", fontFamily:'Poppins', fontSize:'1.3rem' }}>
            Paciente no encontrado
          </Typography>

          <Typography sx={{ mt: 2, mb: 3,  fontFamily:'Poppins', fontSize:'1.2rem', color:"#585857" }}>
            No existe un paciente con ese RUT.
          </Typography>

          <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
            <Button sx={buttonCancelar} onClick={() => setOpenModalError(false)}>
              Cerrar
            </Button>
          </Box>
        </Box>
      </Modal>
    </Box>
    
  );
};